var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-icon"},[_c('img',{attrs:{"src":"https://api.adorable.io/avatars/285/abott@adorable.png","alt":"dataland logo"}})])
}]

export { render, staticRenderFns }